/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import {
  mediaBreakpointUpSM,
  mediaBreakpointDownSM,
  mediaBreakpointUpMD,
  mediaBreakpointUpLG,
  mediaBreakpointUpXL,
  ssColorCyan,
  navHeightWide,
} from '../constants/style-constants';
import { vunit, hunit } from '../lib/style-helpers';

const modalContainerCss = css`
  position: fixed;
  overflow: scroll;
  top: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
  opacity: 0;
  animation: 0.25s ease 0s 1 normal forwards running fadeIn;
  padding-top: ${navHeightWide};
`;

const contentContainerCss = limitWidth => css`
  margin: ${vunit(3)} auto;
  position: relative;
  width: 94%;
  width: calc(100% - 40px);

  ${mediaBreakpointDownSM} {
    width: calc(100% - ${hunit(2)});
  }

  ${mediaBreakpointUpSM} {
    margin-top: ${vunit(14)};
    margin-bottom: ${vunit(7)};
    width: 540px;
  }

  ${mediaBreakpointUpMD} {
    width: 720px;
  }

  ${!limitWidth && css`
    ${mediaBreakpointUpLG} {
      width: 960px;
    }

    ${mediaBreakpointUpXL} {
      width: 1140px;
    }`}
`;

const backgroundCoverCss = css`
  background: rgba(0, 0, 0, 0.8);
  height: inherit;
  position: fixed;
  width: inherit;
`;

const contentCss = css`
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const closeButtonCss = css`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  width: inherit;
  z-index: 1;

  button {
    box-shadow: 0 0 0 6px black;
    border: none;
    background-image: url("https://images.ctfassets.net/gtqjh9j40j4m/450LkmHwsP7SVP22bmkwFa/89618839a67e352df15e1b8df49936c7/onboarding-button-close.svg");
    background-color: black;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 50%;
    background-size: contain;
    color: ${ssColorCyan};
    display: block;
    font-size: 5px;
    height: 17px;
    margin: 18px;
    transition: 0.5s filter;
    width: 17px;

    ${mediaBreakpointUpMD} {
      background-color: transparent;
      box-shadow: none;
      height: 22px;
      width: 22px;
      margin: 20px;
    }

    &:hover {
      cursor: pointer;
      filter: brightness(1.5);
    }

    &:focus {
      outline-style: auto;
    }
  }
`;

const Modal = ({
  show,
  onClose,
  children,
  limitWidth,
}) => {
  useEffect(() => {
    const closeModal = (event) => {
      if (event.keyCode === 27) {
        onClose();
      }
    };

    document.addEventListener('keyup', closeModal);

    return () => {
      document.removeEventListener('keyup', closeModal);
    };
  });

  return (
    show && (
    <div role="dialog" aria-modal="true" css={modalContainerCss}>
      <div
        css={backgroundCoverCss}
        onClick={onClose}
        role="button"
        tabIndex={0}
      />
      <div css={contentContainerCss(limitWidth)}>
        <div css={closeButtonCss}>
          <button type="button" onClick={onClose} />
        </div>
        <div css={contentCss}>
          {children}
        </div>
      </div>
    </div>
    )
  );
};

Modal.defaultProps = {
  show: true,
  limitWidth: false,
};

Modal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  limitWidth: PropTypes.bool,
};

export default Modal;
